// extracted by mini-css-extract-plugin
module.exports = {"novel":"novel-2qB3p9ZK"};